<template>
	<div
		v-if="productHasAttributes"
		class="col-xxs-12 col-sm-6"
	>
		<div
			v-for="attribute in attributes"
			:key="attribute.key"
			class="active-product__attribute-group"
		>
			<h4 class="active-product__attribute__title">{{ attribute.title }}:</h4>
			<ul class="active-product__attributes">
				<li
					v-for="option in attribute.options"
					:key="option.key"
					class="active-product__attribute"
				>
					<label
						:for="getOptionKey( attribute.key, option.key )"
						class="active-product__attribute__label"
					>
						<input
							@change="$emit( 'set_active_attribute', attribute.key, option.value )"
							:id="getOptionKey( attribute.key, option.key )"
							:name="getOptionName( attribute.key )"
							:checked="option.value === attribute.active"
							:value="option.value"
							type="radio"
							class="active-product__attribute__input input-choice input-choice--radio"
						>
						<span class="active-product__attribute__value input-choice-value input-choice-value--radio">
							{{ option.value }}
						</span>
					</label>
				</li>
			</ul>
		</div>
	</div>
</template>


<script>
	import _isEmpty from 'lodash.isempty'


	export default {
		name: 'ProductAttributeGroup',
		props: {
			id: {
				type: Number,
				required: true,
			},
			attributes: {
				type: [ Object, Array ],
				required: true,
			},
		},

		computed: {
			productHasAttributes() {
				return !_isEmpty( this.attributes )
			}
		},

		methods: {
			getOptionKey( attributeKey, optionKey ) {
				return `${this.id}_${attributeKey}_${optionKey}`
			},

			getOptionName( attributeKey ) {
				return `${this.id}_${attributeKey}`
			},

		},	
	}
</script>